import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DOCUMENT,
    ElementRef,
    Inject,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import {Router} from '@angular/router';
import {BehaviorSubject, combineLatest, Observable, of} from 'rxjs';
import {AuthService, RoutingService, WindowRef} from '@spartacus/core';
import {
    LaunchDialogService,
    ProductGridItemComponent,
    ProductListItemContext,
    ProductListItemContextSource,
} from '@spartacus/storefront';
import {map} from 'rxjs/operators';
import {AimoRoutingService} from '../../../../cms-structure/routing/aimo-routing.service';
import {AimoProduct} from '../../../../model/product.model';
import {AimoUser} from '../../../../model/user.model';
import {AimoGTMProductAttributes, GTMCartType, GTMItemListId} from '../../../../service/gtm/aimo-gtm.model';
import {AimoProductModalService} from '../../../../service/product/aimo-product-modal.service';
import {AimoProductService} from '../../../../service/product/aimo-product.service';
import {AimoProductComparisonService} from '../../../../service/user/aimo-product-comparison.service';
import {AimoUserService} from '../../../../service/user/aimo-user.service';
import {DateUtils} from '../../../../shared/util/date-utils';
import {
    AimoOrderTemplateDialogData,
    ORDER_TEMPLATE,
    ProductWrapper
} from '../../../order-template/order-template-modal/aimo-order-template-layout.config';
import {AimoGtmService} from "../../../../service/gtm/aimo-gtm.service";
import {AimoCMSCarouselComponentData, CAROUSEL_TYPE} from "../../../shared/carousel/cms/aimo-cms-carousel.component";

import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {AimoCmsService} from "../../../../cms-structure/routing/aimo-cms.service";
import {AimoCurrentProductService} from "../../../../service/product/aimo-current-product.service";
import {AimoAssortmentService, LabelSuffix} from "../../../../service/product/aimo-assortment.service";
import {AimoUxTypeService} from "../../../../service/general/aimo-ux-type.service";

@Component({
    selector: 'aimo-product-grid-item',
    templateUrl: './aimo-product-grid-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        ProductListItemContextSource,
        {
            provide: ProductListItemContext,
            useExisting: ProductListItemContextSource,
        },
    ],
    standalone: false
})
export class AimoProductGridItemComponent extends ProductGridItemComponent implements OnInit {
    alternative = GTMItemListId.cross_selling;

    @Input() openProductPageFromLink = false;
    @Input() isComparisonProduct = false;
    @Input() showCrossSelling = true;
    @Input() showComparison = true;
    @Input() gtmProductAttributes?: AimoGTMProductAttributes = {};
    @Input() openModalAfterClose?: string;
    @Input() idSuffix: string;
    @Input() parentPopup: NgbPopover;
    protected isStepperVisible = new BehaviorSubject(false);

    addToCartCallBack: BehaviorSubject<number> = new BehaviorSubject(undefined);
    onProductChangeCallBack: BehaviorSubject<AimoProduct> = new BehaviorSubject(undefined);
    loggedUser$: Observable<boolean>;
    user$: Observable<AimoUser>;
    isStepperVisible$ = this.isStepperVisible.asObservable();
    showQuantity = false;
    myAssortmentLabelSuffix$: Observable<LabelSuffix>;
    @ViewChild('popOver') crossSellingProductsPopup: NgbPopover;
    isMobileApp$: Observable<boolean>;

    constructor(
        protected launchDialogService: LaunchDialogService,
        protected currentProductService: AimoCurrentProductService,
        protected aimoUserService: AimoUserService,
        protected routingService: RoutingService,
        protected router: Router,
        protected productListItemContextSource: ProductListItemContextSource,
        protected productComparisonService: AimoProductComparisonService,
        protected cdr: ChangeDetectorRef,
        protected aimoRoutingService: AimoRoutingService,
        protected auth: AuthService,
        protected winRef: WindowRef,
        protected productModalService: AimoProductModalService,
        protected productService: AimoProductService,
        protected gtmService: AimoGtmService,
        protected cmsService: AimoCmsService,
        protected assortmentService: AimoAssortmentService,
        private aimoUxTypeService: AimoUxTypeService,
        @Inject(DOCUMENT) protected document: Document,
    ) {
        super(productListItemContextSource);
        this.isMobileApp$ = this.aimoUxTypeService.isMobileApp();
        this.user$ = this.aimoUserService.get();
        this.loggedUser$ = this.auth.isUserLoggedIn();
        this.crossSellingComponent$ = this.cmsService.getComponentData('AimoCrossellingProductsCarousel');
    }

    ngOnInit(): void {
        // Allow changes to product properties, live availability notification.
        // This way, the changes made will reflect to product summary popup
        this.product = {...this.product};
        this.onProductChangeCallBack.subscribe((product) => {
            if (product) {
                this.product = {...product};
            }
        });
        this.myAssortmentLabelSuffix$ = this.assortmentService.getMyAssortmentLabelSuffix();
    }

    convertDate(d: string): Date {
        return DateUtils.convertDate(d);
    }

    toggleFavorite(): void {
        this.aimoUserService.toggleFavorite(this.product);
        this.product = {...this.product, favorite: !this.product.favorite};
    }

    // eslint-disable-next-line
    openProductModal(event$: any, sourceId: string, scrollToId?: string): void {
        this.closePopup();
        event$?.preventDefault();
        if (this.openProductPageFromLink) {
            this.router.navigate([this.product.url], {});
        } else {
            this.productModalService.openProductModal(
                this.product.code,
                this.gtmProductAttributes,
                scrollToId,
                this.addToCartCallBack,
                this.openModalAfterClose,
                sourceId,
                this.onProductChangeCallBack,
            );
        }
    }

    removeFromComparisonList(productCode: string): void {
        this.productComparisonService.removeProductFromComparison(productCode);
    }

    // eslint-disable-next-line
    autoCloseId: any;

    showHideStepper(event: boolean): void {
        this.isStepperVisible.next(event);
        setTimeout(() => {
            this.showQuantity = event;
            this.cdr.detectChanges();
            if (this.autoCloseId) {
                clearTimeout(this.autoCloseId);
            }
            this.autoCloseId = setTimeout(() => {
                this.hideAddToCart();
            }, 10000);
        }, 250);
    }

    hideAddToCart(): void {
        if (this.showQuantity) {
            setTimeout(() => {
                this.isStepperVisible.next(false);
                this.showQuantity = false;
                this.cdr.detectChanges();
            }, 1000);
        }
    }

    addToComparison(product: AimoProduct): void {
        this.productComparisonService.addProductToComparison(product.code);
    }

    addToOrderTemplate(sourceId: string): void {
        this.launchDialogService.closeDialog(null);
        this.launchDialogService.openDialogAndSubscribe(ORDER_TEMPLATE, undefined, {
            addToTemplateProducts: [new ProductWrapper(this.product, 1)],
            createNew: false,
            focusIdAfterClose: sourceId,
        } as AimoOrderTemplateDialogData);
    }

    isPikatukku(): boolean {
        return this.aimoRoutingService.isPikatukku();
    }

    @ViewChild('productId') productId: ElementRef<HTMLElement>;

    doNotOpen($event: MouseEvent): boolean {
        $event.preventDefault();
        $event.stopPropagation();
        return false;
    }

    crossSellingProducts$: Observable<AimoCMSCarouselComponentData>;
    crossSellingComponent$: Observable<AimoCMSCarouselComponentData>;

    getCrossSellingProducts(product: AimoProduct): Observable<AimoCMSCarouselComponentData> {
        if (this.crossSellingProducts$ == undefined) {
            let idx = 0;
            this.crossSellingProducts$ = combineLatest([
                this.crossSellingComponent$,
                this.productService.getAimoProduct(product.code),
            ]).pipe(
                map(([carouselComponent, fullProduct]) => ({
                    carouselType: CAROUSEL_TYPE.CROSSSELING_PRODUCTS,
                    title: carouselComponent.title,
                    carouselProducts: this.productService
                        .getCrossSellingProducts(fullProduct)
                        ?.map((p) => of({
                            ...p,
                            gtmProductAttributes: {
                                ...this.gtmService.createProductGtmAttributesBase(p, this.alternative),
                                index: idx++,
                                cart_type: GTMCartType.cart,
                            } as AimoGTMProductAttributes
                        }))
                }))
            );
        }
        return this.crossSellingProducts$;
    }

    closePopup(): void {
        this.crossSellingProductsPopup?.close();
        this.parentPopup?.close();
    }
}
